import styled from 'styled-components';
import { mixin } from '@wconcept/wconcept-ui-renewal/styles/index';

/**
 * 레이어는 헤더 바로 아래에서 시작한다.
 * 앱설치 배너(airbridge)가 열리면 헤더가 배너 높이만큼 내려가므로
 * 실측한 헤더 하단 위치($top)를 받아서 잡는다. (index.tsx 참고)
 */
export const CategoryDimLayer = styled.div<{ $top: number }>`
  position: fixed;
  top: ${({ $top }) => $top}px;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.4);
  z-index: 500;

  .category-submenu-list {
    .list {
      width: 40%;
      background-color: #fff;

      .item {
        .btn {
          height: 38px;
          padding: 10px 20px;
          font-weight: 500;
          color: #7b7b7b;
          font-size: 13px;
        }

        &.active {
          .btn {
            background-color: #f9f9f9;
            color: #000;
          }
        }
      }
    }

    .area-sub {
      // flex flow에서 제외 → 레이어 높이는 왼쪽 .list가 결정하고, 넘치면 내부 스크롤
      position: absolute;
      top: 0;
      right: 0;
      bottom: 0;
      width: 60%;
      overflow-y: auto;
      overscroll-behavior: contain;
      -webkit-overflow-scrolling: touch;
      background-color: #f9f9f9;
      padding: 0;

      .sub-list {
        gap: 0;
      }

      .item {
        width: 100%;

        .btn {
          height: 38px;
          padding: 10px 20px;
          font-weight: 500;
          color: #7b7b7b;
          font-size: 13px;
        }

        &.active {
          .btn {
            background-color: #f9f9f9;
            color: #000;
          }
        }
      }
    }
  }

  @media ${({ theme }) => theme.media.smMax} {
    .category-submenu-list {
      .list {
        .item {
          .btn {
            height: ${mixin.pxToVw('38')};
            padding: ${mixin.pxToVw('10')} ${mixin.pxToVw('20')};
            font-size: ${mixin.pxToVw('13')};
          }
        }
      }

      .area-sub {
        .item {
          .btn {
            height: ${mixin.pxToVw('38')};
            padding: ${mixin.pxToVw('10')} ${mixin.pxToVw('20')};
            font-size: ${mixin.pxToVw('13')};
          }
        }
      }
    }
  }
`;
